import React from "react";
import Control from "../../../common/Controls/Control";
import FiltersContainer from "../../../common/FiltersContainer/FiltersContainer";
import useCustomers from "../../../hooks/useCustomers/useCustomers";

const CustomersFilters = () => {
  const { updateFilters, customersState, customersFilters, customersErrors, customers_actions } = useCustomers();
  return (
    <FiltersContainer
      onSubmit={customers_actions.search}
      filtersState={customersState}
      isDataLoaded={customersState.customersSearch.data?.length}
    >
      <div className="row">
        <div className="col-12 col-md-4 offset-md-8">
          <Control
            name="terms"
            type="search"
            value={customersFilters.filters.terms}
            change={customers_actions.updateFilters}
            errors={customersErrors}
            inputStyle={{ background: "white" }}
          />
        </div>
      </div>
    </FiltersContainer>
  );
};

export default CustomersFilters;
